// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


import Vue from 'vue'
import VueResource from 'vue-resource'
import router from './router'
import cognitoAuth from './plugins/cognito'
import stripeApi from './plugins/stripeApi'
import analyticsApi from './plugins/analyticsApi'

import App from './App'
import VueMq from 'vue-mq'
import VueStripeCheckout from 'vue-stripe-checkout';

let stripe_key =  process.env.STRIPE_PK;

const options = {
  key: stripe_key,
  image: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA2NCA2NCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNjQgNjQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojOEJDNTNGO30KCS5zdDF7ZmlsbDojMDBBNjlDO30KCS5zdDJ7ZmlsbDojMjVBOUUwO30KCS5zdDN7ZmlsbDojRkFBRjQwO30KCS5zdDR7ZmlsbDojRjA3M0E0O30KPC9zdHlsZT4KPGc+Cgk8cG9seWdvbiBjbGFzcz0ic3QwIiBwb2ludHM9IjQxLjUsMTkgNTYuMSwyNy4xIDQxLjUsMzUuMyAJIi8+Cgk8cG9seWdvbiBjbGFzcz0ic3QxIiBwb2ludHM9IjU3LDQ1IDQyLjQsMzYuOSA1NywyOC43IAkiLz4KCTxwb2x5Z29uIGNsYXNzPSJzdDIiIHBvaW50cz0iMzkuNiwxOSAyNS4xLDI3LjEgMzkuNiwzNS4zIAkiLz4KCTxwb2x5Z29uIGNsYXNzPSJzdDMiIHBvaW50cz0iMjQuMSw0NSAzOC43LDM2LjkgMjQuMSwyOC43IAkiLz4KCTxwb2x5Z29uIGNsYXNzPSJzdDAiIHBvaW50cz0iMjIuMyw0NSA3LjcsMzYuOSAyMi4zLDI4LjcgCSIvPgoJPHBvbHlnb24gY2xhc3M9InN0NCIgcG9pbnRzPSI2LjcsMTkgMjEuMywyNy4xIDYuNywzNS4zIAkiLz4KPC9nPgo8L3N2Zz4K',
  locale: 'auto',
  currency: 'PHP',
  billingAddress: false,
  panelLabel: 'Subscribe {{amount}}'
}
Vue.use(VueStripeCheckout, options);



import 'materialize'
import 'materialize-css/dist/css/materialize.css'
import M from 'materialize-css/dist/js/materialize.js'

Vue.use(VueResource)
Vue.use(VueMq, {
  breakpoints: {
    sm: 550,
    tb: 768,
    md: Infinity,
  }
})
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  cognitoAuth,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js